/**
 * FAQ — Page script
 */

import { initAccordion }     from '../modules/Components/accordion.js';
import { initTabbedContent } from '../modules/Components/tabbed-content.js';

function init() {
	initAccordion();
	initTabbedContent();
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', init);
} else {
	init();
}
